/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */
import { useLocation, useMatches } from 'react-router';
import {
  init,
  replayIntegration,
  browserTracingIntegration,
} from '@sentry/remix';
import { HydratedRouter } from 'react-router/dom';
import { StrictMode, startTransition, useEffect } from 'react';
import { hydrateRoot } from 'react-dom/client';

init({
  dsn: 'https://09a5bf4bab03acd8fcdcc48fa1d6a477@o4509421651492864.ingest.us.sentry.io/4509421656866816',
  tracesSampleRate: 1,

  integrations: [
    browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
    replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],

  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>,
  );
});
